import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'note',
  })

  return function onClick() {
    submit({ type: 'save' })
  }
}
